<script>
import TablePage from '@/found/components/table_page';

export default {
  extends: TablePage,
  data() {
    return {
      formConfig: {},
    };
  },
  props: {
    propsObj: Object,
  },
  mounted() {
    this.params = { customerCode: this.propsObj.row.customerCode };
    this.getConfigList('customer_rel_terminal_details');
  },
  methods: {

  },
};
</script>
